const state = {
    categories_board_benefits: [],
    subcategories_board: [],
    categories_board: [],
    categories_type: [],
    loading: false,
    category: null,
    modos:[],
};

export default state;